<template>
  <div class="mt-1">
    <b-button variant="outline-primary"
      v-if="showCreateMassiveSummaries"
      @click="openModalCreateMassiveSumaries">
        Crear manifiestos
    </b-button>
    <b-button variant="outline-warning"
      class="ml-2"
      v-if="showEditSummary"
      @click="openModalEditSummaries">
        Editar manifiestos
    </b-button>
    <!-- Componentes -->
    <modal-create-massive-summaries @sendGroupedSummaries="openModalGroupedSummaries"></modal-create-massive-summaries>
    <modal-edit-summary @sendGroupedSummaries="openModalGroupedSummaries" @updateListSummaries="updateListSummaries"></modal-edit-summary>
    <modal-summaries-print :groupedSummaries="groupedSummaries"></modal-summaries-print>
  </div>
</template>

<script>
import BaseServices from '@/store/services/index'
import {endpoint} from './../endpoints.service.js'
import ModalCreateMassiveSummaries from './ModalCreateMassiveSummaries.vue'
import ModalEditSummary from './ModalEditSummary.vue'
import ModalSummariesPrint from './ModalSummariesPrint.vue'
export default {
  name: 'summaries-actions-component',
  props: ['sourceList'],
  components: { ModalCreateMassiveSummaries, ModalEditSummary, ModalSummariesPrint },
  data() {
    return {
      baseService: new BaseServices(this),
      groupedSummaries: [],
      userPermissions: {},
      ROLES : {
        marketplace: 'marketplace',
        ecommerce: 'ecommerce',
        seller: 'seller',
        admin: 'admin'
      }
    }
  },
  mounted () {
    this.setInitialData()
  },
  computed: {
    user() {
      return this.$session.get('cas_user')
    },
    source() {
      return this.sourceList || this.$route.query.source || 'delivery'
    },
    isSourceDelivery() {
      return this.source === 'delivery'
    },
    endpointValues() {
      return endpoint[this.source]
    },
    showCreateMassiveSummaries() {
      return this.userPermissions?.create_massive_summaries && this.isSourceDelivery
    },
    showEditSummary() {
      return this.isSourceDelivery && this.user?.role === this.ROLES.admin
    }
  },
  methods: {
    setInitialData() {
      this.initializeUserPermissions()
    },
    initializeUserPermissions() {
      this.userPermissions = {
        create_massive_summaries: this.user?.user_access?.custom_summaries
      }
    },
    openModalCreateMassiveSumaries() {
      this.$bvModal.show('modalCreateMassiveSummaries')
    },
    openModalEditSummaries() {
      this.$bvModal.show('modalEditSummary')
    },
    openModalGroupedSummaries(data) {
      this.groupedSummaries = data
      this.$bvModal.show('modalSummariesPrint')
    },
    updateListSummaries() {
      this.$emit('updateManifest', true)
    }
  }
}
</script>

<style>

</style>